import {
  regexOnlyLetters,
  regexOnlyNumber,
  regexOnlyStringNumericWithSpecialCharacters,
} from 'shell/constants/regex';
import * as yup from 'yup';

export const cohabitationFormSchema = yup.object({
  person: yup.object().shape({
    surname: yup
      .string()
      .matches(
        regexOnlyStringNumericWithSpecialCharacters,
        'Il campo è alfanumerico con i caratteri speciali spazio, trattino, punto, virgola e apostrofo'
      ),
    name: yup
      .string()
      .matches(
        regexOnlyStringNumericWithSpecialCharacters,
        'Il campo è alfanumerico con i caratteri speciali spazio, trattino, punto, virgola e apostrofo'
      ),
  }),
  generality: yup.object().shape({
    birthDate: yup
      .date()
      .nullable()
      .max(new Date(), 'La data deve essere minore a quella di oggi')
      .typeError('Data non valida'),
  }),
  accordionCohabitation: yup.object().shape({
    originDate: yup.date().nullable().typeError('Data non valida'),
    // .min(new Date(), 'La data deve essere maggiore a quella di oggi'),
    nameCohabitation: yup
      .string()
      .matches(
        regexOnlyStringNumericWithSpecialCharacters,
        'Il campo è alfanumerico con i caratteri speciali spazio, trattino, punto, virgola e apostrofo'
      ),
  }),
  residence: yup.object().shape({
    effectiveDate: yup.date().nullable().typeError('Data non valida'),
    // .min(new Date(), 'La data deve essere maggiore a quella di oggi'),
    toponymCivic: yup.string().matches(regexOnlyNumber, 'Il campo è numerico'),
    toponymExponent: yup.string().matches(regexOnlyNumber, 'Il campo è numerico'),
    toponymLetter: yup.string().matches(regexOnlyLetters, 'Il campo è alfabetico di una lettera'),
    cap: yup
      .string()
      .required('Il campo è obbligatorio')
      .matches(regexOnlyNumber, 'Il campo è numerico'),
  }),
});
